// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var JsxRuntime = require("react/jsx-runtime");
var Image$ReactHooksTemplate = require("./image.res.js");
var DomainModel$ReactHooksTemplate = require("../settings/domainModel.res.js");
var EmailFromId$ReactHooksTemplate = require("../surveys/emailFromId.res.js");
var ToggleInput$ReactHooksTemplate = require("./ToggleInput.res.js");

function EmailSenderPopUp(props) {
  var existingEmails = props.existingEmails;
  var isDisabled = props.isDisabled;
  var onSubmit = props.onSubmit;
  var selectedFromId = props.selectedFromId;
  var onClose = props.onClose;
  var onToggleDefault = Belt_Option.getWithDefault(props.onToggleDefault, (function (param) {
          
        }));
  var validateEmailFormat = function (email) {
    var trimmedEmail = email.trim();
    var emailValue = Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.create, trimmedEmail);
    if (Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.isValid, emailValue)) {
      return false;
    } else {
      return !Curry._1(DomainModel$ReactHooksTemplate.$$String.Email.isEmpty, emailValue);
    }
  };
  var isDuplicateEmail = function (email) {
    var trimmedEmail = email.trim();
    if (trimmedEmail === "") {
      return false;
    } else {
      return Belt_List.some(existingEmails, (function (x) {
                    return EmailFromId$ReactHooksTemplate.fromId(x) === trimmedEmail;
                  }));
    }
  };
  var getValidationError = function (param) {
    var email = EmailFromId$ReactHooksTemplate.fromId(selectedFromId);
    var trimmedEmail = email.trim();
    if (trimmedEmail === "") {
      return "Sender Email cannot be blank";
    } else if (validateEmailFormat(trimmedEmail)) {
      if (isDuplicateEmail(trimmedEmail)) {
        return "Sender Email already taken";
      } else {
        return ;
      }
    } else {
      return "Please enter a valid email address";
    }
  };
  var validationError = getValidationError();
  if (!props.isOpen) {
    return null;
  }
  var match = EmailFromId$ReactHooksTemplate.id(selectedFromId);
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsxs("div", {
                    children: [
                      JsxRuntime.jsx("div", {
                            className: "fixed inset-0 transition-opacity",
                            onClick: (function (param) {
                                Curry._1(onClose, undefined);
                              })
                          }),
                      JsxRuntime.jsx("span", {
                            className: "hidden sm:inline-block sm:align-middle sm:h-screen"
                          }),
                      JsxRuntime.jsxs("div", {
                            children: [
                              JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsxs("div", {
                                                  children: [
                                                    JsxRuntime.jsx("span", {
                                                          children: "🗂️",
                                                          className: "text-lg"
                                                        }),
                                                    JsxRuntime.jsx("h3", {
                                                          children: match !== undefined ? "Update Sender Email" : "Create New Sender Email",
                                                          className: "text-lg font-bold text-gray-900"
                                                        })
                                                  ],
                                                  className: "flex items-center space-x-2"
                                                }),
                                            JsxRuntime.jsx("button", {
                                                  children: JsxRuntime.jsx("img", {
                                                        className: "h-4 w-4",
                                                        src: Image$ReactHooksTemplate.closeIcon
                                                      }),
                                                  className: "text-gray-400 hover:text-gray-600 transition-colors duration-200",
                                                  onClick: (function (param) {
                                                      Curry._1(onClose, undefined);
                                                    })
                                                })
                                          ],
                                          className: "flex items-center justify-between"
                                        }),
                                    className: "bg-gradient-to-r from-blue-50 via-indigo-50 to-purple-50 px-6 py-4 border-b border-gray-200"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsxs("div", {
                                            children: [
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("label", {
                                                            children: "Sender Email",
                                                            className: "block text-sm font-medium text-gray-700 mb-2"
                                                          }),
                                                      JsxRuntime.jsx("input", {
                                                            className: "w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200",
                                                            placeholder: "Enter sender email",
                                                            type: "text",
                                                            value: EmailFromId$ReactHooksTemplate.fromId(selectedFromId),
                                                            onChange: props.onUpdateEmail
                                                          })
                                                    ],
                                                    className: "w-full"
                                                  }),
                                              JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsx("label", {
                                                            children: "Default",
                                                            className: "text-sm font-medium text-gray-700 h-6 flex items-center"
                                                          }),
                                                      JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                                                  checked: EmailFromId$ReactHooksTemplate.default(selectedFromId),
                                                                  disabled: isDisabled || validationError !== undefined,
                                                                  handleChange: (function (param) {
                                                                      Curry._1(onToggleDefault, undefined);
                                                                    }),
                                                                  labelClassName: "flex items-center"
                                                                }),
                                                            className: "flex items-center justify-center h-10"
                                                          })
                                                    ],
                                                    className: "ml-6 flex flex-col"
                                                  })
                                            ],
                                            className: "flex items-start"
                                          }),
                                      validationError !== undefined ? JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsx("p", {
                                                    children: validationError,
                                                    className: "text-red-500 text-xs"
                                                  }),
                                              className: "mt-4"
                                            }) : null
                                    ],
                                    className: "p-6"
                                  }),
                              JsxRuntime.jsxs("div", {
                                    children: [
                                      JsxRuntime.jsx("button", {
                                            children: "Cancel",
                                            className: "px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200",
                                            onClick: (function (param) {
                                                Curry._1(onClose, undefined);
                                              })
                                          }),
                                      JsxRuntime.jsx("button", {
                                            children: "Save",
                                            className: "px-6 py-2 text-sm font-medium text-white rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 transition-colors duration-200 " + (
                                              isDisabled || validationError !== undefined ? "bg-gray-400 cursor-not-allowed" : "bg-blue-600 hover:bg-blue-700"
                                            ),
                                            disabled: isDisabled || validationError !== undefined,
                                            onClick: (function (param) {
                                                Curry._1(onSubmit, selectedFromId);
                                              })
                                          })
                                    ],
                                    className: "bg-gray-50 px-6 py-4 border-t border-gray-200 flex justify-end space-x-3"
                                  })
                            ],
                            className: "inline-block align-bottom bg-white rounded-2xl shadow-2xl border border-gray-100 transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full overflow-hidden"
                          })
                    ],
                    className: "flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0"
                  }),
              className: "fixed inset-0 z-50 overflow-y-auto",
              style: {
                backgroundColor: "rgba(0, 0, 0, 0.6)"
              }
            });
}

var make = EmailSenderPopUp;

exports.make = make;
/* react/jsx-runtime Not a pure module */
